import { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { URL, ADMIN } from "../../../../lib/lib.js";
import "./component.css";

const Component = ({componentTitle}) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    productId: '',
    hotelId: '',
    status: true,
  });

  const [products, setProducts] = useState([]);
  const [hotels, setHotels] = useState([]);

  useEffect(() => { fetchProducts(); fetchHotels(); }, []);

  const fetchProducts = async () => {
    try {
      const response = await fetch(URL + ADMIN.product_view, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include'
      });
      const data = await response.json();
      setProducts(data.data);
    } catch (error) {
      console.error('Error fetching products:', error);
    }
  };

  const fetchHotels = async () => {
    try {
      const response = await fetch(URL + ADMIN.hotel_view, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: 'include'
      });
      const data = await response.json();
      setHotels(data.data);
    } catch (error) {
      console.error('Error fetching hotels:', error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  // Fetch user data if editing (for pre-filling the form)
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const response = await fetch(URL + ADMIN.menu_view, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({id}),
          credentials: 'include'
        });
        const result = await response.json();
        const data = result.data;
        if (data) {
          setFormData({
            productId: data.productId?._id || '',
            hotelId: data.hotelId?._id || '',
          });
        }
      } catch (err) {
        console.error("Failed to fetch user details:", err);
      }
    };
  
    if (id) {
      getUserDetails();
    }
  }, [id]);


  // Form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    const dataToSend = { ...formData };
    if (id) dataToSend.id = id;
  
    try {
      const request = await fetch(URL + (id ? ADMIN.menu_update : ADMIN.menu_create), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(dataToSend),
        credentials: "include",
      });

      if (request.status === 201 || request.status === 200) {
        let response = await request.json();
        console.log(response);
        alert(response.message);
        navigate('/admin/menu');
      }
      
    } catch (error) {
      console.error("Error:", error);
      alert(error.response?.data?.message || "Something went wrong.");
    }
  };

  return (
    <div id="adduser" className="container-fluid">
      <div className="row profile-my_flx_profile_up">
        <div className="col-xl-2 col-lg-3 col-md-2 profile-pro1 profile-admin">
          <Link to="/admin/menu">
            <button className="profile-back">
              <i className="ri-arrow-left-s-line profile-lefticon"></i>
            </button>
          </Link>
        </div>
        <div className="col-xl-8 col-lg-6 col-md-8">
          <div className="profile-my_form_signup_profile">

            <form onSubmit={handleSubmit}>
              <p className="profile-login_head">{id ? "Edit" : "Create"} {componentTitle}</p>
              
              <div className="row">

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Product</label>
                  <select name="productId" value={formData.productId} onChange={handleChange} className="form-control" required>
                    <option value="">Select Product</option>
                    {products.map((product) => (<option key={product.id} value={product._id}>{product.name}</option>))}
                  </select>
                </div>

                <div className="col-md-6 p-2">
                  <label className="form-label profile-user_label">Hotel</label>
                  <select name="hotelId" value={formData.hotelId} onChange={handleChange} className="form-control" required>
                    <option value="">Select Hotel</option>
                    {hotels.map((hotel) => (<option key={hotel.id} value={hotel._id}>{hotel.name}</option>))}
                  </select>
                </div>

                {id && (
                  <div className="col-md-12 p-2">
                    <label className="form-label profile-user_label">Status</label>
                    <select name="status" value={formData.status} onChange={handleChange} className="form-control" required={id} >
                      <option value="">Select Status</option>
                      <option value="true">Active</option>
                      <option value="false">Inactive</option>
                    </select>
                  </div>
                )}

              </div>

              <button type="submit" className="profile-submit_bot1">{id ? "Update" : "Create"} {componentTitle}</button>
            </form>
          </div>
        </div>
        <div className="col-xl-2 col-lg-3 col-md-2"></div>
      </div>
    </div>
  );
};

export default Component;
